export default __webpack_public_path__ + "static/2-3abe14d5a53053d3ceaa432d114c4cc1.png";